var map = {
	"./black/lixianrenwu2.png": "ZEzg",
	"./blue/lixianrenwu2.png": "744H",
	"./white/lixianrenwu2.png": "ROzh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mDra";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/lixianrenwu2\.png$
// module id = mDra
// module chunks = 24